var render = function render(){var _vm=this,_c=_vm._self._c;return _c('tabs',{attrs:{"parent":"supports"}},[_c('tab',{attrs:{"id":"ticket_list","name":_vm.translate('support.tabs.tickets'),"href":_vm.url+'/ticket_list'}},[_c('TicketList')],1),_c('tab',{attrs:{"id":"mail_list","name":_vm.translate('support.tabs.mails'),"href":_vm.url+'/mail_list'}},[_c('MailList')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }